import { GlBadge, GlLink, GlSprintf, GlToken, GlTooltipDirective, GlTruncateText } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import * as Sentry from '~/sentry/sentry_browser_wrapper';
import { s__ } from '~/locale';
import { helpPagePath } from '~/helpers/help_page_helper';
import { convertToTitleCase } from '~/lib/utils/text_utility';
import glAbilitiesMixin from '~/vue_shared/mixins/gl_abilities_mixin';
import { canReadMcpServer } from '../permissions';
import { getByVersionKey, isGitLabMaintainedItem } from '../utils';
import { AGENT_VISIBILITY_LEVEL_DESCRIPTIONS, AI_CATALOG_TYPE_THIRD_PARTY_FLOW } from '../constants';
import aiCatalogMcpToolsQuery from '../graphql/queries/ai_catalog_mcp_tools.query.graphql';
import AiCatalogItemField from './ai_catalog_item_field.vue';
import AiCatalogItemFieldServiceAccount from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/components/ai_catalog_item_field_service_account.vue?vue3';
import AiCatalogItemVisibilityField from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/components/ai_catalog_item_visibility_field.vue?vue3';
import FormFlowDefinition from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/components/form_flow_definition.vue?vue3';
import TriggerField from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/components/trigger_field.vue?vue3';
import FormSection from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/components/form_section.vue?vue3';
export default {
    name: 'AiCatalogAgentDetails',
    components: {
        AiCatalogItemField,
        AiCatalogItemFieldServiceAccount,
        AiCatalogItemVisibilityField,
        FormFlowDefinition,
        FormSection,
        GlBadge,
        GlLink,
        GlSprintf,
        GlToken,
        GlTruncateText,
        TriggerField
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        glAbilitiesMixin()
    ],
    inject: {
        instanceBetaFeaturesEnabled: {
            default: false
        }
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        versionKey: {
            type: String,
            required: true
        }
    },
    apollo: {
        availableMcpTools: {
            query: aiCatalogMcpToolsQuery,
            update: (data)=>Object.fromEntries((data.aiCatalogMcpTools?.nodes ?? []).map((t)=>[
                        t.name,
                        t
                    ])),
            error (error) {
                Sentry.captureException(error);
            }
        }
    },
    data () {
        return {
            availableMcpTools: {}
        };
    },
    truncateTextToggleButtonProps: {
        class: 'gl-font-regular'
    },
    computed: {
        isGitLabMaintained () {
            return isGitLabMaintainedItem(this.item);
        },
        projectName () {
            return this.item.project?.nameWithNamespace;
        },
        version () {
            return getByVersionKey(this.item, this.versionKey);
        },
        mcpToolsEnabled () {
            return this.instanceBetaFeaturesEnabled;
        },
        tools () {
            const builtInTools = (this.version.tools?.nodes ?? []).map((t)=>({
                    key: `builtin-${t.id}`,
                    title: t.title,
                    description: t.description,
                    source: 'builtin',
                    iconUrl: null,
                    disabled: false
                }));
            const mcpTools = (this.version.mcpTools ?? []).map((name)=>{
                const enriched = this.availableMcpTools?.[name];
                const icon = enriched?.icons?.find((i)=>i.theme === 'light') || enriched?.icons?.[0];
                return {
                    key: `mcp-${name}`,
                    title: enriched?.title ?? convertToTitleCase(name.replace(/_/g, ' ')),
                    description: enriched?.description ?? '',
                    source: 'mcp',
                    iconUrl: icon?.src ?? null,
                    disabled: !this.mcpToolsEnabled
                };
            });
            return [
                ...builtInTools,
                ...mcpTools
            ].sort((a, b)=>a.title.localeCompare(b.title));
        },
        mcpServers () {
            return [
                ...this.version.mcpServers?.nodes ?? []
            ].sort((a, b)=>a.name.localeCompare(b.name));
        },
        systemPrompt () {
            return this.version.systemPrompt;
        },
        definition () {
            return this.version.definition;
        },
        isThirdPartyFlow () {
            return this.item.itemType === AI_CATALOG_TYPE_THIRD_PARTY_FLOW;
        },
        typeField () {
            if (this.isThirdPartyFlow) {
                return s__('AICatalog|External');
            }
            if (this.item.foundational) {
                return s__('AICatalog|Foundational');
            }
            return s__('AICatalog|Custom');
        },
        hasProjectConfiguration () {
            return Boolean(this.item.configurationForProject);
        },
        serviceAccount () {
            if (this.hasProjectConfiguration) {
                return this.item.configurationForProject?.flowTriggers?.[0]?.user;
            }
            return this.item.configurationForGroup?.serviceAccount;
        },
        canReadMcpServers () {
            return canReadMcpServer({
                glAbilities: this.glAbilities
            });
        }
    },
    methods: {
        tokenStyleFor (tool) {
            if (tool.source !== 'mcp' || tool.disabled) return null;
            return {
                borderColor: 'var(--gl-feedback-warning-border-color)',
                backgroundColor: 'var(--gl-feedback-warning-background-color)'
            };
        }
    },
    AGENT_VISIBILITY_LEVEL_DESCRIPTIONS,
    toolsDocsLink: helpPagePath('user/duo_agent_platform/agents/tools')
};
